import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Gallery from "./pages/Gallery.tsx";
import Generate from "./pages/Generate.tsx"
import PublicGallery from "./pages/PublicGallery.tsx";
import PublicImagePage from "./pages/PublicImagePage";
import Plans from "./pages/Plans";
import "./index.css";

function parseHash(h: string) {
  // h типа "#/p/123" | "#/gallery" | "#/public"
  const clean = h.startsWith("#") ? h.slice(1) : h;   // "/p/123"
  const parts = clean.split("?")[0].split("/").filter(Boolean); // ["p","123"]

  // Маршруты:
  //  /gallery
  if (parts[0] === "gallery") return { route: "gallery" as const };
  //  /public
  if (parts[0] === "public")  return { route: "public"  as const };
  //  /p/:id
  if (parts[0] === "p" && parts[1]) return { route: "p" as const, id: parts[1] };

  if (parts[0] === "generate")  return { route: "generate"  as const };

  if (parts[0] === "plans") return { route: "plans" as const };


  return { route: "home" as const };
}

function Root() {
  const [hash, setHash] = React.useState(location.hash);
  React.useEffect(() => {
    const onHash = () => setHash(location.hash);
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  const r = parseHash(hash);

  if (r.route === "gallery") return <Gallery />;
  if (r.route === "public")  return <PublicGallery />;
  if (r.route === "p")       return <PublicImagePage imageId={r.id} />;
  if (r.route === "generate")return <Generate/>;
  if (r.route === "plans") return <Plans />;


  return <App />;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
